import { Routes } from '@angular/router';
import { RegisterComponent } from './register/register.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { ErrorComponent } from './error/error.component';
import { EndedComponent } from './ended/ended.component';
import { authGuard } from './guards/auth-guard.guard';


export const routes: Routes = [
    {path: '', component: RegisterComponent, canActivate: [authGuard]},
    {path: 'confirmation', component: ConfirmationComponent},
    {path: 'error', component: ErrorComponent},
    {path: 'ended', component: EndedComponent},
    {
        path: '**',
        redirectTo: ''
    }
];
